import React from 'react';
import { connect } from "react-redux";
import Loader from '../../../../Global/loader.js'
//import { store } from 'react-notifications-component';
import { withNamespaces } from 'react-i18next';
//import XLSX from 'xlsx';
import 'react-drop-zone/dist/styles.css'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import DropFile from './DropFile'
import ErrorList from './ErrorList.js';
import { Button, Row, Col } from 'react-bootstrap';
import { BsBackspaceFill } from 'react-icons/bs'

class ImportReport extends React.Component {
    state={
        loading: true,
        selectedFile: [],
        files: [],
        uploadingReport: false,
        themeColor: "test",
        pathColor: "#000",
        correctErrors: false
    }

    componentDidMount = async () => {
        this.setState({loading: true})  

        await this.ResetAll()
        
        this.setState({
            loading: false
        })
    }

    updateFiles = (files) => {    
        this.setState({ 
            files: [],
            selectedFile: []
        })        
       
        if(files.length > 0){
            import('xlsx').then(XLSX => {
                this.setState({ files })
                var f = files[0].file;

                var zson = []
                const reader = new FileReader();
                reader.readAsBinaryString(f);

                reader.onload = (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, { type: "binary" });           
                    var sheet_name_list = wb.SheetNames;
                    zson = XLSX.utils.sheet_to_json(wb.Sheets[sheet_name_list[0]]);

                    zson.map((data,index) => {
                        zson[index]["selected"] = false
                        zson[index]["STVARNA CIJENA"] = parseFloat(zson[index]["STVARNA CIJENA"] * 1.00)
                        zson[index]["index"] = index
                        zson[index]["Error"] = false
                        return null
                    })

                    this.setState({ selectedFile: zson });
                };
            })
        }       
      };

    removeFile = async (id) => {       
        //let file = this.state.files.filter((x) => x.id !== id);
        this.setState({ files: [] })
        this.setState({loading: false})
    };

    sendReport = async () => {
        let boja, pozadina

        if(this.props.themeColor === 'darkBlue'){
            boja = "#162A6C"
            pozadina= "#DCE8FD"      
            
        }
        else if(this.props.themeColor === 'red'){
            boja = "#E62020"
            pozadina= "#FFDBDC"
        }
        else if(this.props.themeColor === 'black'){
            boja = "#FFF"
            pozadina= "#DCE8FD"
        }
        else if(this.props.themeColor === 'green'){
            boja = "#008C4D"
            pozadina= "#C2FADC"
        }
        else if(this.props.themeColor === 'yellow'){
            boja = "#FAA700"
            pozadina= "#FFF6B5"
        }
        else if(this.props.themeColor === 'orange'){
            boja = "#B53F00"
            pozadina= "#FFE1C4"
        }
        else if(this.props.themeColor === 'purple'){
            boja = "#7231F5"
            pozadina= "#EAE1FC"
        }
        this.setState({
             uploadingReport: true,
             themeColor: boja,
             pathColor: pozadina
        })

        var i = 0;
        var errors = 0;
        for(i; i < this.state.selectedFile.length ; i++){
            let data = this.state.selectedFile[i]

            errors = errors + 1;
            this.props.mapState("MAP_REPORTS_ERROR", errors)
            this.props.mapState("MAP_REPORTS_ERROR_LIST", data)
        }
        
        await this.props.mapState("MAP_REPORTS_UPLOAD_PERCENTAGE", 100)
        await this.setState({
            correctErrors: true,            
        })
    }

    ResetAll = () => {
        this.props.mapState("MAP_REPORTS_ERROR_LIST_RESET", true)
        this.props.mapState("MAP_REPORTS_ERROR", 0)
        this.setState({ 
            uploadingReport : false,
            selectedFile: [],
            files: []
        })
    }

    CorrectErrors = () => {
        this.setState({
            correctErrors: true,            
        })
        this.props.mapState("MAP_REPORTS_UPLOAD_PERCENTAGE", 0)
    }

    render(){
        const { 
            loading, 
            files, 
            selectedFile, 
            themeColor, 
            pathColor,
            correctErrors
        } = this.state 
        const { t } = this.props

    return (
        !correctErrors ?
            loading ? 
                <Loader />
            : 
                <div className="container border-0">
                    {!this.state.uploadingReport ?   
                        <Row>  
                            <Col className="p-4">
                                <DropFile
                                    files={files}
                                    updateFiles={this.updateFiles}
                                    selectedFile={selectedFile}
                                    removeFile={this.removeFile}
                                    sendReport={this.sendReport}
                                    t={t}
                                />
                            </Col>
                        </Row>
                    :
                        <Row className="izvjestaj justify-content-center mt-4">
                            <div className="w-50 h-50">
                                <CircularProgressbar
                                    value={this.props.percentage}
                                    text={`${this.props.percentage}%`}
                                    styles={buildStyles({
                                        // Rotation of path and trail, in number of turns (0-1)
                                        //: 0.25,

                                        // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                                        strokeLinecap: 'butt',

                                        // Text size
                                        textSize: '16px',

                                        // How long animation takes to go from one percentage to another, in seconds
                                        pathTransitionDuration: 0.5,

                                        // Can specify path transition in more detail, or remove it entirely
                                        // pathTransition: 'none',

                                        // Colors
                                        pathColor: themeColor,
                                        textColor: themeColor,
                                        trailColor: pathColor,
                                        backgroundColor: '#000',
                                    })}
                                />
                            </div>

                            {this.props.reportsError > 0 &&
                                <h1> Errors: {this.props.reportsError} </h1>
                            }
                            

                            {this.props.percentage === 100 ?
                                this.props.reportsError > 0 ?
                                    <Row className="justify-content-center">                                    
                                            <Button 
                                                variant="danger" 
                                                className="w-auto"
                                                onClick={() =>this.CorrectErrors()}
                                            >
                                                {t('Correct errors')}
                                            </Button>                                    
                                    </Row>
                                :
                                    <Row className="justify-content-center text-center">                                    
                                        <h1> Success !!! </h1>
                                        <span>Number of transactions: {this.state.selectedFile.length}</span>
                                    </Row>
                            : null } 

                            {this.props.percentage === 100 ? 
                                    <Row>   
                                        <Button 
                                            variant="default"
                                            onClick={() =>this.ResetAll()}
                                            className="col-2 mb-2"             
                                        > 
                                            <BsBackspaceFill size={30} />  
                                            <strong> {t('Back')} </strong>
                                        </Button> 
                                    </Row>
                            : null}

                           
                           
                        </Row>
                    }        
                </div>
        :
            <ErrorList />
    )
}
}
const mapStateToProps = state => {
    return {   
        themeColor: state.user.user_web_properties.settings.themeColor,
        providerId: state.user.provider_uuid,
        percentage: state.report.percentage,
        reportErrorList: state.report.reportErrorList,
        reportsError: state.report.reportsError
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
   
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(ImportReport));